/**
 * Single source of truth for user-facing labels of OHIF's
 * `reconstruction_blocker` codes. Codes are produced by the backend
 * predicate `is_reconstructable.py`; adding a new code there requires
 * extending this map in the same change. Consumers choose their own
 * fallback policy for unknown codes.
 */

export type BlockerCode =
  | "no_instances"
  | "single_instance"
  | "missing_ipp"
  | "missing_iop"
  | "missing_pixel_spacing"
  | "missing_for"
  | "inconsistent_dimensions"
  | "inconsistent_iop"
  | "irregular_spacing"
  | "degenerate_ipp";

export const BLOCKER_LABELS: Record<BlockerCode, string> = {
  single_instance: "Single frame",
  missing_ipp: "Missing slice positions",
  missing_iop: "Missing orientation",
  missing_pixel_spacing: "Missing pixel spacing",
  missing_for: "Missing frame of reference",
  inconsistent_dimensions: "Inconsistent dimensions across slices",
  inconsistent_iop: "Inconsistent orientation across slices",
  irregular_spacing: "Irregular slice spacing",
  degenerate_ipp: "All slices share one position",
  no_instances: "No instances",
};
